/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 3/5/21
 * Copyright All Rights Reserved
 */
export const COGNITO_NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';



// WEBPACK FOOTER //
// ./js/constants/cognitoAuthChallenges.js